import { z } from 'zod';

export const PROFILE_SHEETS = ['dados-pessoais', 'alterar-senha'] as const;
export type ProfileSheet = (typeof PROFILE_SHEETS)[number];

/** Os dois drawers do legado viram sheets na URL (U39 §2): o voltar fecha. */
export const profileSearch = z.object({ sheet: z.enum(PROFILE_SHEETS).optional().catch(undefined) });
export const notificationSettingsSearch = z.object({ sheet: z.string().optional().catch(undefined) });
